import { buildSectionClassname } from './classNameUtils';
import { writeBackgroundLayersToCss } from './backgroundLayerStylesUtils';
import { writeMargin, writeMaxWidthToCss, writePadding, isStyleOverridden } from './gridLayoutStyleUtils';
import combineBreakpointStyles from './combineBreakpointStyles';
function writeMaxWidthToCssRuleTriple(styles, sectionSelector, breakpointMediaQueries, ruleTriples) {
  breakpointMediaQueries.forEach(([breakpointName, mediaQuery]) => {
    const style = styles[breakpointName];
    if (!style) {
      return;
    }
    if (style.contentWidth) {
      const styleList = [];
      writeMaxWidthToCss(style.contentWidth, styleList);
      ruleTriples.push([`${sectionSelector} ${sectionSelector}-content`, styleList.join(' '), mediaQuery]);
    }
  });
  return ruleTriples;
}
function writeSectionStylesToCssHelper(styles, existingStylesByBreakpointName) {
  Object.keys(styles).forEach(breakpointName => {
    const stylesForBreakpoint = existingStylesByBreakpointName[breakpointName] || [];
    const style = styles[breakpointName];
    if (isStyleOverridden(style.isHidden)) {
      stylesForBreakpoint.push(`display: ${style.isHidden ? 'none' : 'block'};`);
    }
    if (isStyleOverridden(style.padding)) {
      stylesForBreakpoint.push(writePadding(style.padding));
    }
    if (isStyleOverridden(style.margin)) {
      stylesForBreakpoint.push(writeMargin(style.margin));
    }
    existingStylesByBreakpointName[breakpointName] = stylesForBreakpoint;
  });
}
export default function writeSectionStylesToCss(nodeId, styles, breakpointMediaQueries) {
  const nodeSelector = `.${buildSectionClassname(nodeId)}`;
  const stylesByBreakpointName = {};
  const backgroundLayerStylesByBreakpointName = {};
  const backgroundLayersByBreakpointName = Object.keys(styles).reduce((acc, breakpointName) => {
    const stylesForBreakpoint = styles[breakpointName];
    if (stylesForBreakpoint !== null && stylesForBreakpoint !== void 0 && stylesForBreakpoint.backgroundLayers) {
      acc[breakpointName] = stylesForBreakpoint.backgroundLayers;
    }
    return acc;
  }, {});
  writeBackgroundLayersToCss(nodeId, backgroundLayersByBreakpointName, backgroundLayerStylesByBreakpointName);
  writeSectionStylesToCssHelper(styles, stylesByBreakpointName);
  const combinedBreakpointStyles = combineBreakpointStyles(breakpointMediaQueries, stylesByBreakpointName, nodeId, backgroundLayerStylesByBreakpointName, nodeSelector);
  writeMaxWidthToCssRuleTriple(styles, nodeSelector, breakpointMediaQueries, combinedBreakpointStyles);
  return combinedBreakpointStyles;
}